import React, { useEffect, useState } from "react";
import {useTranslation} from "react-i18next";
import CheckBoxRefinementList from "../CheckBoxRefinementList";
import PartnerResultPanel from "./PartnerResultPanel";

export default function PartnerFilterPanel(props) {
  const [filterOpen, setfilterOpen] = React.useState(true);
  const { t, i18n } = useTranslation();

  const handleChange = () => {
    setfilterOpen(!filterOpen);
    const btn_el = document.querySelector(".js-btn-filter");
    const panel_el = document.querySelector(".js-filters-panel");


    btn_el.classList.toggle('open');
    panel_el.classList.toggle('filters-open');


  };

  return (
      <React.Fragment>
          <div className="form-search partners-form-search js-form-search filters-open js-filters-panel">

              <div className="form__body">
                  <aside className="form__aside">
                      <div className="section__recently-joined">
                          <div className="widgets-recently-joined">
                              <div className="widgets__head">
                                  <h3>Filter By Material Types</h3>
                              </div>

                              <div className="widgets__body">
                                  <div className="widgets__items widgets__items--partner-filters">
                                      <CheckBoxRefinementList
                                          limit={20}
                                          operator="or"
                                          attribute="material_type_names"
                                          initialFacets={window.all_material_types}
                                      />
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div className="individual__actions">
                          <a href="#" className="btn btn--outline" onClick={props.onMessageShow}>
                              Compose A Message To The Selected Partners
                          </a>
                      </div>
                  </aside>
                  <div className="form__content form__content-partners">
                      <PartnerResultPanel/>
                  </div>
              </div>
          </div>
      </React.Fragment>
  );
}
